<template>
  <div class="add-technologyBom">
    <el-row>
      <el-col :span="24" style="text-align: center; margin-bottom: 20px">
        <span class="el-dialog__title">工艺参数模板配置</span>
      </el-col>
    </el-row>
    <div class="main">
      <div class="mubanList">
        <!-- <el-button type="primary" size="mini" @click="addTemplate">添加模板</el-button> -->
        <div class="listTitle">
          工艺参数模板名称
          <i class="el-icon-circle-plus addTemplateButton" @click="addTemplate"></i>
        </div>

        <div class="templateList">
          <div
            :class="['template', activeTemplate.id == item.id ? 'activeTemplate' : '']"
            v-for="(item, index) in templateList"
            :key="index"
            @click="chooseTemplate(item)"
          >
            <div class="templateName">
              {{ item.modelName }}
            </div>
            <div>
              <el-button type="text" size="small" @click="editTemplate(item)"
                >编辑</el-button
              >
              <el-divider direction="vertical"> </el-divider>
              <el-button type="text" size="small" @click="deleteTemplate(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <el-divider direction="vertical"> </el-divider>
      <div class="mubanContent">
        <el-table :data="tableData" max-height="600">
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <i
                class="el-icon-top"
                style="color: #007acc; cursor: pointer; font-size: 16px"
                @click="upItem(scope.$index)"
              ></i>
              <i
                class="el-icon-bottom"
                style="color: #007acc; cursor: pointer; font-size: 16px"
                @click="downItem(scope.$index)"
              ></i>
              <i
                class="el-icon-delete"
                v-if="tableData.length > 1"
                style="color: red; cursor: pointer; font-size: 16px"
                @click="delItem(scope.$index)"
              ></i>
              <i
                @click="addItem(scope.$index)"
                v-if="tableData.length == scope.$index + 1"
                class="el-icon-circle-plus-outline"
                style="color: #007acc; cursor: pointer; font-size: 16px; font-weight: 700"
              ></i>
            </template>
          </el-table-column>

          <el-table-column width="80" label="序号" type="index"></el-table-column>

          <el-table-column label="机组">
            <template slot-scope="scope">
              <el-select
                filterable
                v-model="scope.row.factoryModelId"
                collapse-tags
                placeholder="机组名称"
                clearable
              >
                <el-option
                  v-for="item in factoryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="参数名称">
            <template slot-scope="scope">
              <el-input
                size="small"
                maxlength="16"
                v-model="scope.row.parameterName"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="参数值">
            <template slot-scope="scope">
              <el-input
                size="small"
                maxlength="16"
                v-model="scope.row.parameterValue"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="下限值">
            <template slot-scope="scope">
              <el-input
                size="small"
                maxlength="16"
                v-model="scope.row.lowerLimit"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="上限值">
            <template slot-scope="scope">
              <el-input
                size="small"
                maxlength="16"
                v-model="scope.row.upperLimit"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="描述信息">
            <template slot-scope="scope">
              <el-input
                :maxlength="100"
                size="small"
                v-model="scope.row.description"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-row style="margin-top: 20px">
      <el-col :span="24" style="text-align: center">
        <el-button type="primary" @click="submitTable">提 交</el-button>
        <el-button @click="cancelAdd">返 回</el-button>
      </el-col>
    </el-row>
    <el-dialog
      :title="addTemplateType == 'add' ? '添加模板' : '编辑模板'"
      :visible.sync="addTemplateVisible"
      width="400px"
      @close="closeAddTemplate"
    >
      <el-form
        :model="addTemplateForm"
        ref="addTemplateForm"
        :rules="rules"
        label-width="120px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="模板名称：" prop="name">
          <el-input class="formValue" v-model="addTemplateForm.name"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="addTemplateVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTemplate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonUtils from "../../util/CommonUtils";

export default {
  data() {
    return {
      factoryModelList: [],
      tableData: [{}],
      activeTemplate: {},
      addTemplateVisible: false,
      addTemplateType: "add",
      templateList: [],
      addTemplateForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      permission: JSON.parse(localStorage.getItem("permission")),
    };
  },
  components: {},
  mounted: async function () {
    this.getTemplateList();
    this.loadFactoryModelList();
  },
  methods: {
    async loadFactoryModelList() {
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/factoryModel/getWorkShopList",
        params: {},
      });
      this.factoryModelList = data;
    },
    cancelAdd() {
      this.$parent.initTable();
      this.$parent.showPage = 1;
    },
    getTemplateList() {
      this.$RequestUtil.get({
        url: "/api/technology-params/list-model",
        params: {},
        success: (res) => {
          if (res.code == 0) {
            this.templateList = res.data;
          }
        },
      });
    },
    addTemplate() {
      this.addTemplateType = "add";
      this.addTemplateVisible = true;
    },
    submitTemplate() {
      this.$refs["addTemplateForm"].validate((valid) => {
        if (valid) {
          let url = "/api/technology-params/create-model";
          let params = {
            id: "",
            modelName: this.addTemplateForm.name,
          };
          if (this.addTemplateType == "edit") {
            url = "/api/technology-params/update-model";
            params.id = this.addTemplateForm.id;
          }
          this.$RequestUtil.post({
            url: url,
            params: params,
            success: (res) => {
              if (res.code == 0) {
                this.$message.success("操作成功");
                this.getTemplateList();
                this.addTemplateVisible = false;
              }
            },
          });
        }
      });
    },
    editTemplate(row) {
      this.addTemplateType = "edit";
      this.addTemplateForm.id = row.id;
      this.addTemplateForm.name = row.modelName;
      this.addTemplateVisible = true;
    },
    closeAddTemplate() {
      this.addTemplateForm.name = "";
    },
    deleteTemplate(row) {
      this.$confirm("此操作将删除模板, 是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/technology-params/delete-model",
          params: {
            id: row.id,
          },
          success: (res) => {
            if (res.code == 0) {
              this.$message.success("操作成功");
              this.getTemplateList();
            }
          },
        });
      });
    },
    chooseTemplate(item) {
      this.activeTemplate = item;
      this.getTemplateContent(item.id);
    },
    getTemplateContent(templateId) {
      this.$RequestUtil.get({
        url: "/api/technology-params/model-item",
        params: {
          modelId: templateId,
        },
        success: (res) => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.tableData = res.data;
            } else {
              this.tableData = [{}];
            }
          }
        },
      });
    },
    addItem() {
      if (!this.activeTemplate.id) {
        this.$message.warning("请选择工艺模板");
        return;
      }
      this.tableData.push({});
    },
    delItem(index) {
      this.tableData.splice(index, 1);
    },
    upItem(index) {
      if (index != 0) {
        const item = this.tableData.splice(index, 1);
        this.tableData.splice(index - 1, 0, ...item);
      }
    },
    downItem(index) {
      if (index != this.tableData.length - 1) {
        const item = this.tableData.splice(index, 1);
        this.tableData.splice(index + 1, 0, ...item);
      }
    },
    submitTable() {
      if (!this.activeTemplate.id) {
        this.$message.warning("请选择工艺模板");
        return;
      }
      let isCheck = true;
      let title = "";
      for (let j = 0; j < this.tableData.length; j++) {
        let sub = this.tableData[j];
        this.tableData[j].seqNo = j;
        if (!sub.parameterName || (sub.parameterName && !sub.parameterName.trim())) {
          isCheck = false;
          title = `第${j + 1}条参数名称必填`;
        }
        if (sub.lowerLimit) {
          let { isPass, errTxt } = this.checkNum(
            sub.lowerLimit,
            `第${j + 1}条自定义参数下限值`,
            0,
            4
          );
          if (!isPass) {
            isCheck = isPass;
            title = errTxt;
            break;
          }
        }
        if (sub.upperLimit) {
          let { isPass, errTxt } = this.checkNum(
            sub.upperLimit,
            `第${j + 1}条自定义参数上限值`,
            0,
            4
          );
          if (!isPass) {
            isCheck = isPass;
            title = errTxt;
            break;
          }
        }
      }
      if (!isCheck) {
        this.$message.error(title);
        return;
      }
      this.$RequestUtil.post({
        url: "/api/technology-params/submit-item",
        params: {
          modelId: this.activeTemplate.id,
          list: this.tableData,
        },
        success: (res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
          }
        },
      });
    },
    checkNum(num, name, type, maxNum = 2) {
      //校验保留两位小数 如果错误返回错误原因
      let res = {
        isPass: true,
        errTxt: "",
      };
      num = Number(num);
      if (isNaN(num)) {
        res.isPass = false;
        res.errTxt = name + "必须为数字";
        return res;
      }
      if (num <= 0) {
        res.isPass = false;
        res.errTxt = name + "必须大于零";
        return res;
      }
      if (num.toFixed(maxNum) != num) {
        res.isPass = false;
        res.errTxt = name + `最多可保留${maxNum}位小数`;
        return res;
      }
      if (type == 1) {
        if (num > 100) {
          res.isPass = false;
          res.errTxt = name + "不能大于100";
          return res;
        }
      }
      return res;
    },
  },
};
</script>

<style scoped>
.activeTemplate {
  background: rgb(214, 217, 218);
}
.formValue {
  width: 180px;
}
.add-technologyBom {
  background: white;
  padding: 20px;
}
.main {
  display: flex;
}
.mubanList {
  width: 20%;
  min-height: 400px;
}
.listTitle {
  position: relative;
  width: 100%;
  line-height: 50px;
  background: #ebf9ff;
  padding-left: 14px;
  box-sizing: border-box;
}
.addTemplateButton {
  text-align: center;
  position: absolute;
  right: 20px;
  line-height: 50px;
  color: #409eff;
  font-size: 20px;
}
.mubanContent {
  width: 80%;
}
.main > .el-divider--vertical {
  height: unset;
}
.template {
  display: flex;
  padding-left: 1em;
  padding-right: 1em;
  justify-content: space-between;
  line-height: 32px;
  border: 1px solid #ccc;
}
.template:not(:last-of-type) {
  border-bottom: 0;
}
.templateName {
  width: 60%;
  overflow: hidden;
  text-wrap: nowrap;
}
.templateList {
  max-height: 500px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/TechnologyBOM/AddTechnology.vue